const ALL = 'ALL';
const WHITE = 'WHITE';
const BLACK = 'BLACK';

export default {
  ALL,
  WHITE,
  BLACK
};
